import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens, SEMANTIC } from "./tokens";

/**
 * Closed-Loop Tracker (§5.6) — barra de pasos con estado por paso.
 * Muestra el ciclo Detección → Acción → Validación → Resultado (o el journey
 * del encuentro en CDCI: Schedule → Context → Note → Charges → Sign).
 *
 * @param {Object[]} steps
 * @param {string}   steps[].label
 * @param {"done"|"active"|"pending"|"blocked"} steps[].state
 */
export default function ClosedLoopTracker({ steps = [], sx }) {
  const styleFor = (state) => {
    switch (state) {
      case "done":
        return { fg: SEMANTIC.ok.fg, bg: SEMANTIC.ok.bg, symbol: "✓" };
      case "active":
        return { fg: tokens.primary, bg: tokens.primary50, symbol: "●" };
      case "blocked":
        return { fg: SEMANTIC.crit.fg, bg: SEMANTIC.crit.bg, symbol: "▲" };
      default:
        return { fg: tokens.ink3, bg: tokens.mutedBg, symbol: "○" };
    }
  };

  return (
    <Stack direction="row" alignItems="center" sx={{ flexWrap: "wrap", gap: 0.5, ...sx }}>
      {steps.map((s, i) => {
        const st = styleFor(s.state);
        return (
          <React.Fragment key={s.label}>
            {i > 0 && (
              <Box sx={{ width: 16, height: "1px", bgcolor: tokens.lineStrong }} />
            )}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.7,
                px: 1.2,
                py: "3px",
                borderRadius: "4px",
                bgcolor: st.bg,
                border: `1px solid ${s.state === "active" ? tokens.primary : "transparent"}`,
              }}
            >
              <Typography component="span" sx={{ fontSize: 11, color: st.fg, lineHeight: 1 }}>
                {st.symbol}
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontSize: 12.5,
                  fontWeight: s.state === "active" ? 600 : 500,
                  color: st.fg,
                  whiteSpace: "nowrap",
                }}
              >
                {s.label}
              </Typography>
            </Box>
          </React.Fragment>
        );
      })}
    </Stack>
  );
}
